<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
            <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
            <b-card no-body :header="$t('general.isometric_management.best_prefabrication.calculate_title')" header-tag="h3" class="bg-default-card">
                <span v-if="showTableBarLoader">
                    <BarLoader 
                        class="my-custom-bar-loader"
                        :color="'#6f9fe6'"
                    >
                    </BarLoader>
                </span>
                <span style="padding: 1.25rem;" :class="showTableBarLoader ? 'disabled-custom-class' : ''">
                    <isometric-management-best
                        ref="isometricManagementBest"
                        :weldPlace="'sw'"
                        :columnData="columnData"
                        @showBarLoader="showBarLoader"
                    >
                    </isometric-management-best>
                </span>
            </b-card>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import isometricManagementBest from '@/components/pages/project/isometric_management/calculation/isometric_management_best.vue';
import { BarLoader } from '@saeris/vue-spinners';

export default {
    name: 'isometric_management_best_prefabrication',
    components: {
        isometricManagementBest,
        BarLoader,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/ '+ this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.isometric_management.title'),
                    to: '/project/' + this.$route.params.id + '/isometric_management',
                },
                {
                    text: Vue.i18n.translate('general.isometric_management.best_prefabrication.calculate_title'),
                    to: '/project/' + this.$route.params.id + '/isometric_management',
                },
            ],

            columnData: [
                {
                    label: Vue.i18n.translate('table.isometric'),
                    field: 'info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.total_dia_inch_prefabrication'),
                    field: 'total_dia_inch_prefabrication',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.priority'),
                    field: 'priority',
                    numeric: false,
                    html: false,
                },
            ],

            showTableBarLoader: false,
        }
    },
    mounted() {
        
    },
    methods: {
        showBarLoader (value) {
            this.showTableBarLoader = value;
        },
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/project/isometric_management/calculation/isometric_management_best_prefabrication.vue